/* TORQEN — Stripe request flow.
 *
 * Deliberately a SEPARATE file from torqen.js. torqen.js is the finder, the
 * fitment index, the configurator and the supplier brief, and it is left byte
 * for byte as it was. Everything the Stripe flow adds lives here, so removing
 * the feature means deleting this file and one line in layout/theme.liquid.
 *
 * HOW SHOPIFY CHECKOUT IS BLOCKED
 * -------------------------------
 * Not by this file. The section templates simply do not render the Shopify
 * cart plumbing when a Request backend URL is configured: no /cart/add action,
 * no fee variant id, no quantity, no return_to. There is nothing for the
 * browser to send to Shopify even with JavaScript switched off, broken, or
 * still loading. That is the primary guarantee, and it does not depend on any
 * listener firing in time.
 *
 * This file adds three further layers on top of that:
 *   1. a submit listener whose first two statements are preventDefault and
 *      stopPropagation;
 *   2. an override of the form's native submit() method, because a programmatic
 *      form.submit() from any other script does NOT fire a submit event and so
 *      cannot be stopped by a listener;
 *   3. a report, readable with ?tqdebug=1, stating in plain terms whether each
 *      of those is actually in place on the page you are looking at.
 *
 * ORDER MATTERS. torqen.js registers its own submit handler when it loads, and
 * that handler is what fills #tqBrief with the supplier brief. This file loads
 * after it, so its handler runs second and the brief is already built by the
 * time the questionnaire is posted.
 */
(function () {
  'use strict';

  var PAY = window.TORQEN_PAY || {};
  /* Trailing slashes are stripped here rather than in Liquid, where the only
     available filter removes the last slash ANYWHERE in the string and would
     turn "https://host" into "https:/host". */
  var API = PAY.apiUrl ? String(PAY.apiUrl).trim().replace(/\/+$/, '') : '';
  var I18N = PAY.i18n || {};
  var CFG_AXES = ['Material', 'Carbon', 'Stitching', 'LED', 'Heating', 'Paddles', 'Buttons'];

  var backendEnabled = !!(PAY.enabled && API);
  var payErrors = [];

  function note(e) {
    var msg = 'pay: ' + String(e && e.message || e);
    payErrors.push(msg);
    var d = window.TORQEN_DEBUG;
    if (d && d.errors) d.errors.push(msg);
    if (window.console && console.warn) console.warn('[TORQEN] ' + msg);
  }

  /* Any uncaught error anywhere on the page is recorded too, so a failure in
     an unrelated script that happens to break this one is visible rather than
     silent. */
  window.addEventListener('error', function (ev) {
    if (ev && ev.message) payErrors.push('window: ' + ev.message);
  });

  /* Every form that the section rendered in Stripe mode. Normally exactly one.
     Selecting by attribute rather than by id means a page that somehow carried
     two request forms would have both intercepted, not just the first. */
  var forms = Array.prototype.slice.call(
    document.querySelectorAll('form[data-tq-mode="stripe"]')
  );
  /* Fallback for a cached page rendered before this change shipped: the form
     is still #requestForm, it just has no mode attribute yet. */
  if (!forms.length) {
    var legacy = document.querySelector('#requestForm');
    if (legacy && backendEnabled) forms = [legacy];
  }

  var intercepted = [];
  var nativeSubmitOverridden = false;

  /* Evidence, not a flag someone set optimistically. Reads the DOM and reports
     what is actually true of the form in front of the customer. */
  function shopifySubmitBlocked() {
    if (!forms.length) return false;
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var action = (f.getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/cart') !== -1) return false;   // still posts to the cart
      if (f.querySelector('[name="id"]')) return false;   // still carries a variant
      if (f.querySelector('[name="quantity"]')) return false;
      if (f.querySelector('[name="return_to"]')) return false;
    }
    return nativeSubmitOverridden;
  }

  /* ------------------------------------------------------ diagnostics
     Wraps the report torqen.js publishes rather than editing it, so the two
     files stay independent. */
  var baseReport = window.TORQEN_REPORT;
  window.TORQEN_REPORT = function () {
    var r = (typeof baseReport === 'function') ? baseReport() : {};
    var f = forms[0] || null;
    r.payment = {
      mode: (backendEnabled && intercepted.length) ? 'stripe-payment-link' : 'shopify-checkout',
      backendEnabled: backendEnabled,
      submitInterceptorAttached: intercepted.length > 0,
      interceptedFormCount: intercepted.length,
      stripeFlowActive: backendEnabled && intercepted.length > 0,
      originalShopifySubmitBlocked: shopifySubmitBlocked(),
      nativeSubmitOverridden: nativeSubmitOverridden,
      formMode: f ? (f.getAttribute('data-tq-mode') || 'none') : 'no-form',
      formAction: f ? (f.getAttribute('action') || '(none)') : null,
      cartFieldsPresent: f ? {
        variantId: !!f.querySelector('[name="id"]'),
        quantity: !!f.querySelector('[name="quantity"]'),
        returnTo: !!f.querySelector('[name="return_to"]')
      } : null,
      backendUrl: API || null,
      locale: PAY.locale || null,
      statusRegion: !!(f && f.querySelector('#tqPayStatus')),
      customerFields: f ? {
        name: !!f.querySelector('#tqName'),
        email: !!f.querySelector('#tqEmail'),
        phone: !!f.querySelector('#tqPhone')
      } : null,
      fetchSupported: typeof window.fetch === 'function',
      stringsLoaded: !!I18N.cta,
      paymentErrors: payErrors
    };
    return r;
  };

  try {
    if (window.location && String(window.location.search).indexOf('tqdebug=1') > -1) {
      var d = window.TORQEN_REPORT().payment;
      window.console && console.info(
        'TORQEN PAYMENT\n' +
        '  mode: ' + d.mode + '\n' +
        '  backendEnabled: ' + d.backendEnabled + '\n' +
        '  submitInterceptorAttached: ' + d.submitInterceptorAttached + '\n' +
        '  interceptedFormCount: ' + d.interceptedFormCount + '\n' +
        '  stripeFlowActive: ' + d.stripeFlowActive + '\n' +
        '  originalShopifySubmitBlocked: ' + d.originalShopifySubmitBlocked + '\n' +
        '  formMode: ' + d.formMode + '   formAction: ' + d.formAction + '\n' +
        '  backend: ' + (d.backendUrl || 'not configured') + '\n' +
        '  errors: ' + (d.paymentErrors.length ? d.paymentErrors.join(' | ') : 'none'));
    }
  } catch (e) { note(e); }

  if (!backendEnabled || !forms.length || typeof window.fetch !== 'function') return;

  /* ------------------------------------------------------------ helpers */

  var form = forms[0];
  var payBtn = form.querySelector('#tqSubmit') || form.querySelector('button[type=submit]');
  var payBox = form.querySelector('#tqPayStatus');
  var brief = form.querySelector('#tqBrief');
  var payLabel = payBtn ? payBtn.textContent.trim() : '';
  var submitting = false;

  if (payBtn && I18N.cta) { payBtn.textContent = I18N.cta; payLabel = I18N.cta; }

  // Everything written into the status box goes through here, so a request id
  // or an error string from the server can never be interpreted as markup.
  function esc(v) {
    var d = document.createElement('div');
    d.textContent = String(v == null ? '' : v);
    return d.innerHTML;
  }
  function show(markup, tone) {
    if (!payBox) return;
    payBox.hidden = false;
    payBox.className = 'paynote' + (tone ? ' paynote--' + tone : '');
    payBox.innerHTML = markup;
  }

  /* The select VALUES are brand slugs and generation indexes, so the readable
     option TEXT is sent instead - the same text the supplier brief prints.
     This mirrors selText() in torqen.js, which is private to that file. */
  function selText(name) {
    var el = form.querySelector('[name="properties[' + name + ']"]');
    if (!el || !el.value) return '';
    return (el.tagName === 'SELECT' && el.selectedIndex > -1)
      ? el.options[el.selectedIndex].text
      : el.value;
  }
  function propValue(name) {
    var el = form.querySelector('[name="properties[' + name + ']"]');
    return el ? el.value : '';
  }
  function fieldValue(sel) {
    var el = form.querySelector(sel);
    return el ? el.value : '';
  }
  function cfgValue(key) {
    var g = form.querySelector('[data-cfg="' + key + '"]');
    if (!g) return '';
    var c = g.querySelector('input[type=radio]:checked');
    return (c && c.value) || '';
  }

  function done(id, url) {
    show(
      '<div class="paynote__ref"><span>' + esc(I18N.savedRef || 'Request ID') +
      '</span><b>' + esc(id) + '</b></div>' +
      '<p>' + esc(I18N.redirecting || '') + '</p>' +
      '<p class="paynote__keep">' + esc(I18N.keep || '') + '</p>' +
      '<a class="btn btn--primary" href="' + String(url).replace(/"/g, '&quot;') + '">' +
      esc(I18N.manual || 'Continue') + '</a>', 'ok');
    if (payBtn) payBtn.hidden = true;
    if (payBox && payBox.scrollIntoView) {
      try { payBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }

    /* Tells the backend the customer has been handed the Stripe link, which
       moves the record from "questionnaire submitted" to "payment pending" -
       and nothing more. A page the customer can reach must never be able to
       mark a request PAID. If this call fails it does not matter: the backend
       reconciles the real status against Stripe either way. */
    try {
      fetch(API + '/api/requests/' + id + '/redirected', { method: 'POST', keepalive: true })
        .catch(function () {});
    } catch (e) {}

    // A short pause so the customer actually sees, and can note down, their
    // request number before Stripe takes over the window.
    setTimeout(function () { window.location.href = url; }, 2200);
  }

  function startSubmission() {
    if (submitting) return;              // second click, double tap, Enter twice
    submitting = true;
    if (payBtn) { payBtn.disabled = true; payBtn.textContent = I18N.saving || 'Saving...'; }
    show(esc(I18N.saving || 'Saving...'));

    var fd = new FormData();
    fd.append('source', form.querySelector('[name="properties[_Request type]"]') ? 'custom' : 'product');
    fd.append('locale', PAY.locale || 'en');
    fd.append('customer_name',  fieldValue('#tqName'));
    fd.append('customer_email', fieldValue('#tqEmail'));
    fd.append('customer_phone', fieldValue('#tqPhone'));
    fd.append('wheel_title',    propValue('Steering wheel'));
    fd.append('wheel_handle',   propValue('_Wheel handle'));
    fd.append('wheel_wanted',   propValue('Wheel wanted'));
    fd.append('vehicle_brand',      selText('Vehicle brand'));
    fd.append('vehicle_model',      selText('Vehicle model'));
    fd.append('vehicle_generation', selText('Generation'));
    fd.append('vehicle_year',       selText('Year'));
    CFG_AXES.forEach(function (k) { fd.append('opt_' + k.toLowerCase(), cfgValue(k)); });
    fd.append('current_wheel_description', propValue('Current wheel description'));
    fd.append('customer_notes',            propValue('Customer notes'));
    fd.append('supplier_brief',            brief ? brief.value : '');
    var file = form.querySelector('input[type=file]');
    if (file && file.files && file.files[0]) fd.append('photo', file.files[0]);

    fetch(API + '/api/requests', { method: 'POST', body: fd })
      .then(function (r) {
        return r.text().then(function (txt) {
          var j = null;
          try { j = JSON.parse(txt); } catch (e) {}
          return { ok: r.ok, status: r.status, j: j };
        });
      })
      .then(function (res) {
        if (!res.ok || !res.j || !res.j.ok || !res.j.pay_url) {
          throw new Error((res.j && res.j.error) || ('http_' + res.status));
        }
        done(res.j.request_id, res.j.pay_url);
      })
      .catch(function (e) {
        /* Nothing was stored, so nothing is sent to Stripe, and nothing is sent
           to Shopify either - there is no cart action on this form to fall back
           to. The customer stays on the page with everything they typed. */
        submitting = false;
        if (payBtn) { payBtn.disabled = false; payBtn.textContent = payLabel; }
        show(esc(I18N.error || 'We could not save your request.'), 'err');
        note(e);
      });
  }

  /* --------------------------------------------------------- interception */

  forms.forEach(function (f) {
    /* BUBBLE PHASE, NOT CAPTURE - and the reason is not stylistic.
       The event's target is the form itself, so the browser visits the form
       once while capturing and again while bubbling. Calling stopPropagation()
       during the capturing visit cancels the bubbling visit on the SAME
       element, which silently killed torqen.js's own submit listener - the one
       that fills #tqBrief with the supplier brief. Every request would have
       reached the owner with an empty brief. Registering here instead means
       torqen.js (registered earlier) runs first and the brief is built before
       this handler reads it.

       Nothing is lost defensively: preventDefault cancels the submission
       whatever phase it is called in, and the one thing a listener genuinely
       cannot stop - a programmatic form.submit() - is blocked below by
       replacing the method itself. */
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      if (f === form) startSubmission();
    });
    intercepted.push(f);

    /* form.submit() called programmatically does NOT fire a submit event, so no
       listener can stop it. Replacing the method on this element is the only
       way to be certain another script cannot post the form to Shopify. */
    try {
      f.submit = function () { note('a script attempted form.submit(); blocked'); };
      nativeSubmitOverridden = true;
    } catch (e) { note(e); }
  });

  /* The submit event above is what normally runs, and it must be allowed to
     happen: torqen.js listens for it too, and that is where #tqBrief is filled
     with the supplier brief. So this click handler deliberately does NOT call
     preventDefault - it waits one tick and only acts if no submit event
     arrived, which would mean something else suppressed it. Belt and braces
     without stepping on the brief. */
  if (payBtn) {
    payBtn.addEventListener('click', function () {
      setTimeout(function () {
        if (submitting) return;                    // the submit path handled it
        if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
        note('submit event did not fire; driving the submission from the click');
        startSubmission();
      }, 0);
    });
  }
})();
